import type { Section } from '../../../models/index';
import InsufficientFundsFee_v1 from './InsufficientFundsFee_v1';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function InsufficientFundsFee_v2(props: Props) {
  return <InsufficientFundsFee_v1 {...props} />;
}

InsufficientFundsFee_v2.description = 'Insufficient Funds Fee with an Oregon specific helper text';
